import { useEffect, useState } from "react";
import api from "@/lib/api";

export default function AdminAudit() {
  const [logs, setLogs] = useState([]);

  useEffect(() => { api.get("/admin/audit-logs").then((r) => setLogs(r.data)).catch(() => {}); }, []);

  return (
    <div>
      <p className="eyebrow">Security</p>
      <h1 className="mt-3 font-serif text-3xl tracking-tight">Audit Logs</h1>
      <p className="mt-2 font-sans text-sm text-[#94A3B8]">Immutable record of sensitive actions — uploads, downloads, status changes, and offer generation.</p>

      <div className="mt-8 overflow-hidden rounded-lg border border-white/5">
        <table className="w-full text-left">
          <thead className="bg-[#18202E]">
            <tr className="font-mono text-[10px] uppercase tracking-widest text-[#94A3B8]">
              <th className="px-5 py-3">Time</th><th className="px-5 py-3">Actor</th><th className="px-5 py-3">Action</th><th className="px-5 py-3">Entity</th>
            </tr>
          </thead>
          <tbody>
            {logs.map((l) => (
              <tr key={l.id} data-testid={`audit-row-${l.id}`} className="border-t border-white/5">
                <td className="px-5 py-3 font-mono text-[10px] text-[#94A3B8]">{new Date(l.created_at).toLocaleString()}</td>
                <td className="px-5 py-3 font-sans text-xs">{l.actor_email || "system"}<br /><span className="text-[10px] text-[#94A3B8]">{l.actor_role || "—"}</span></td>
                <td className="px-5 py-3"><span className="rounded-full bg-gold/10 px-2.5 py-0.5 font-mono text-[10px] uppercase tracking-widest text-gold">{l.action}</span></td>
                <td className="px-5 py-3 font-mono text-[10px] text-[#94A3B8]">{l.entity_type}{l.entity_id ? ` · ${l.entity_id.slice(0, 8)}` : ""}</td>
              </tr>
            ))}
            {logs.length === 0 && <tr><td colSpan={4} className="px-5 py-12 text-center font-sans text-sm text-[#94A3B8]">No audit entries yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
